import { IsString, IsOptional } from 'class-validator';
import { RoleInterface } from './role.interface';
import { AbstractModel } from '../models/abstract.model';
import { GrantInterface } from '../grant';

export class RoleModel extends AbstractModel implements RoleInterface {

    @IsString()
    public name: string = '';

    @IsString()
    @IsOptional()
    public description?: string;

    public grants?: GrantInterface[];

    constructor(name: string = '', description?: string) {
        super();
        this.name = name;
        this.description = description;
    }

}
